/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Groupssystemremoved2Inputs */

const en_groupssystemremoved2 = /** @type {(inputs: Groupssystemremoved2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} was removed`)
};

const de_groupssystemremoved2 = /** @type {(inputs: Groupssystemremoved2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} wurde entfernt`)
};

/**
* | output |
* | --- |
* | "{name} was removed" |
*
* @param {Groupssystemremoved2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const groupssystemremoved2 = /** @type {((inputs: Groupssystemremoved2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Groupssystemremoved2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_groupssystemremoved2(inputs)
	return de_groupssystemremoved2(inputs)
});
export { groupssystemremoved2 as "groupsSystemRemoved" }